// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "168500b3d64a46df9842a217c3c68d96e40d1900/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};